import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/tailwind.css'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import store from './store'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import appInfo from './app-info'
import config from './config'
import Inputmask from 'inputmask'
// vueGoodTable plugin
import VueGoodTablePlugin from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
// Splide
import '@splidejs/splide/dist/css/themes/splide-default.min.css'

// app info
Vue.prototype.$appInfo = appInfo

Vue.use(axios)
Vue.use(ElementUI, { locale })
Vue.config.productionTip = false

axios.defaults.baseURL = config.baseUrl
Vue.prototype.$axios = axios

// vue leaflet js
Vue.component('l-map', LMap)
Vue.component('l-tile-layer', LTileLayer)
Vue.component('l-marker', LMarker)

// vue-good-table
Vue.use(VueGoodTablePlugin)

// loading screen
Vue.prototype.loading = function (e) {
  return this.$loading({
    lock: true,
    text: 'Loading',
    spinner: 'el-icon-loading'
  })
}

// Inputmask
Vue.directive('input-mask', {
  bind: function (el, binding) {
    var inputs = el.getElementsByTagName('INPUT')
    var input = inputs[0]
    if (inputs.length > 1) {
      input = inputs[inputs.length - 1]
    }
    new Inputmask(binding.value).mask(input)
  }
})

axios.interceptors.request.use(
  (config) => {
    // let token = localStorage.getItem('access_token')
    let token = Vue.$cookies.get('__auth')

    if (token) {
      config.headers['Authorization'] = token
    }
    return config
  },

  (error) => {
    return Promise.reject(error)
  }
)

new Vue({
  router,
  axios,
  store,
  render: (h) => h(App)
}).$mount('#app')
